import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryTemplateArgs, Template, TemplateSearchTemplateVersionsArgs } from "types/generated";

type GetTemplateVersionsForDeployData = {
  template: Pick<Template, "id" | "searchTemplateVersions">;
};

export const GET_TEMPLATE_VERSIONS_FOR_DEPLOY: TypedDocumentNode<
  GetTemplateVersionsForDeployData,
  QueryTemplateArgs & TemplateSearchTemplateVersionsArgs
> = gql`
  query GetTemplateVersionsForDeploy($id: ID!, $input: SearchInput!) {
    template(id: $id) {
      id
      searchTemplateVersions(input: $input) {
        edges {
          node {
            id
            version
            deprecatedAt
          }
        }
      }
    }
  }
`;
